/** Coupled applications and dependency systems from the application graph. */

export function linkedApplicationIds(app, { includeSelf = false } = {}) {
  const nodes = app?.dependencies?.nodes || [];
  const ids = new Set();
  for (const node of nodes) {
    for (const id of node.impact?.apps || []) {
      if (!id) continue;
      if (!includeSelf && id === app?.id) continue;
      ids.add(id);
    }
  }
  return Array.from(ids).sort();
}

export function linkedApplicationRows(app, portfolio) {
  const catalog = Object.fromEntries((portfolio?.applications || []).map((a) => [a.id, a]));
  return linkedApplicationIds(app).map((id) => ({
    id,
    name: catalog[id]?.name || id,
    stage: catalog[id]?.stage,
    recommendation: catalog[id]?.recommendation,
  }));
}

export function dependencySystemNodes(app) {
  return (app?.dependencies?.nodes || []).filter((n) => n.kind !== "self");
}

export function systemsForApplication(appId, nodes) {
  return (nodes || [])
    .filter((n) => (n.impact?.apps || []).includes(appId))
    .map((n) => n.label || n.id);
}
